import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {SHOP_CATEGORIES_LIST} from "../../../enums/e-shop-categories";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-shop",
    templateUrl: "./go-shop.component.html"
})


export class GoShopComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;
    SHOP_CATEGORIES_LIST = SHOP_CATEGORIES_LIST;


    constructor() {
        super(GO_COMPONENTS.SHOP);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-shop/go-shop.component.ts